import * as React from 'react'
import {
  StyledSearchHereButton,
  StyledSearchHereIcon,
} from '$views/FullMapCaretakers/components/SearchHereButton/SearchHereButton.style'
import { Block } from '$views/components'
import { Spinner } from '$views/components/Spinner'
import { Text } from '$views/components'

const iconClock = require('$icons/reload.svg')

interface Props {
  onClick: () => void
  isLoading: boolean
}

export const SearchHereButton: React.FC<Props> = ({ onClick, isLoading }) => {
  return (
    <StyledSearchHereButton mini tertiary onClick={onClick} withIcon>
      {isLoading ? (
        <Spinner horizontal />
      ) : (
        <Block flex>
          <StyledSearchHereIcon content={iconClock} size="m" color="darkGrey" />
          <Text weight="medium">Refrescar</Text>
        </Block>
      )}
    </StyledSearchHereButton>
  )
}



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/SearchHereButton/SearchHereButton.tsx